const findIndex = (arr, identifier, searchValue) => arr.findIndex(item => item[identifier] === searchValue);

export default findIndex;
